import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';

function Loader({showLoader}) {

    // let showLoader = useSelector(state => state.session.showLoader);

    if (!showLoader) {
        return null;
    }

    return (
        <div
            style={{position: 'absolute',left: '48%', top: '48%'}}
        >
            <CircularProgress />
        </div>
    );
}

export default Loader;
